import { classNames } from 'tradera/utils/class-names';
import styles from './dropdown-menu.module.scss';

type Props = {
    label?: React.ReactNode;
    className?: string;
};
export const MenuItemSeparator = ({ label, className = '' }: Props) => (
    <li
        className={classNames(
            'text-center',
            className,
            styles.siteDropdownSeparator
        )}>
        {label}
    </li>
);
